import { useLocation } from 'react-router-dom';

import {
  type CategoryBlockLayout,
  type CategoryBlockSurface,
  categoryBlockProductList,
} from '~/services/analytics/productLists';
import type { Category } from '~/stores/CategoriesStore';

const blockSurface = (pathname: string): CategoryBlockSurface => {
  if (pathname === '/search') {
    return 'search';
  }
  return pathname.startsWith('/shop') ? 'shop' : 'home';
};

export const useCategoryBlockProductList = (
  category: Pick<Category, 'id' | 'name'>,
  layout: CategoryBlockLayout,
) => {
  const { pathname } = useLocation();

  return categoryBlockProductList(
    category.id,
    category.name,
    blockSurface(pathname),
    layout,
  );
};
